/**
 * Minimal current / upcoming season notice for ops marketing prep.
 */

import { Alert, Space, Tag, Typography } from "antd";

const { Text } = Typography;

/**
 * @param {{ briefing?: object|null, compact?: boolean }} props
 */
export default function SeasonOpsBrief({ briefing = null, compact = false }) {
  if (!briefing?.headline) return null;

  const upcomingSoon =
    briefing.upcoming &&
    Number(briefing.upcoming.daysUntil) >= 0 &&
    Number(briefing.upcoming.daysUntil) <= 21;

  return (
    <Alert
      type={upcomingSoon ? "warning" : "info"}
      showIcon
      data-testid="season-ops-brief"
      style={compact ? { marginBottom: 0 } : undefined}
      message={
        <Space wrap size="small">
          <Text strong>{briefing.headline}</Text>
          {briefing.automationEnabled ? (
            <Tag color="green" style={{ margin: 0 }}>
              Season live
            </Tag>
          ) : (
            <Tag style={{ margin: 0 }}>Calendar preview</Tag>
          )}
        </Space>
      }
      description={
        <Space direction="vertical" size={2} style={{ width: "100%" }}>
          <Text type="secondary" style={{ fontSize: 13 }}>
            {briefing.prepNote}
          </Text>
          {!compact && briefing.upcoming && !upcomingSoon ? (
            <Text type="secondary" style={{ fontSize: 12 }}>
              Next change: {briefing.upcoming.label} on{" "}
              {briefing.upcoming.startsOn} ({briefing.upcoming.daysUntil}d)
            </Text>
          ) : null}
        </Space>
      }
    />
  );
}
